export default __webpack_public_path__ + "static/media/mindfulness-icon.37305852.svg";